import { gql } from "@apollo/client"

const GET_SITE_DATA_STAFF_SUMMARY = gql`
  query ($clientId: ID!) {
    dataStaffSummary(client_id: $clientId) {
      data_age
      imported_at
      total
      sync_count
      custom_count
      missing_lesson_count
    }
  }
`

export { GET_SITE_DATA_STAFF_SUMMARY }
